import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import lazyAntd from '@/antd-components/lazy_antd'
import pinia from '@/store/index'
import { createDB } from '@/utils/indexDBUtils'
import '@/styles/index.scss'
import '@/styles/antdv-const.scss'
import '@/iconfont/iconfont.css'

const app = createApp(App)
// 在创建 Pinia store 实例前，先确保 Pinia 已正确初始化
app.use(pinia)

// 按需引用
lazyAntd(app)

// 创建数据库并挂在页面
createDB(() => {
  app.use(router).mount('#app')
})

